<template>
    <div>
        <BaseSection>
            <BaseCardCollection
                v-if="isPending || (cards && cards.length)"
                :cards="cards || []"
                :wide="true"
                :placeholder="isPending"
            />
            <p v-else>Sorry, there are no press releases available.</p>
        </BaseSection>
        <BaseSection>
            <BasePaginator
                :current-page="currentPage"
                :total-pages="Math.ceil(total / 16)"
                @update:current-page="currentPage = $event"
            />
        </BaseSection>
    </div>
</template>

<script setup>
import PressReleasesOverview from '~/graphql/queries/PressReleases/overview.graphql';

const currentPage = useCurrentPage();

const { variables } = useCraftVariables();
variables.uri = undefined;

variables.limit = 16;

const route = useRoute();
watchEffect(() => {
    variables.offset = route.query.page ? (route.query.page - 1) * variables.limit : 0;
});

const response = await useAsyncQuery({
    query: PressReleasesOverview,
    variables
});

const { data, isPending } = response;

const items = computed(() => {
    return data.value?.entries;
});

const { formatSingleDate, formats } = useDate();
const { getCardPills } = usePillsCard();

const cards = computed(() => {
    if (items?.value ?? items?.value?.length) {
        return items.value?.map((pressReleases) => {
            return {
                title: pressReleases.title,
                meta: formatSingleDate(pressReleases.postDate, formats.dayMonthYear),
                uri: pressReleases.uri,
                pills: getCardPills(pressReleases),
            };
        });
    }
    return null;
});

const total = computed(() => {
    return data.value?.entryCount;
});

watch(() => currentPage.value, () => {
    window.scrollTo(0, 0);
});

</script>

<!-- <script>
export default {
    components: {
        // UroPaginator,
        // UroSection,
        // CardCollection
    },

    mixins: [
        // pillsCards
    ],

    data() {
        return {
            items: null,
            total: null,
            currentPage: null
        };
    },

    async fetch() {
        const { data } = await this.$gql.executeQuery(PressReleasesOverviewQuery, { offset: (this.currentPage - 1) * 16 });
        this.items = data.entries;
        this.total = data.entryCount;
    },

    computed: {
        cards() {
            if (this.items?.length) {
                return this.items.map((pressReleases) => {
                    return {
                        title: pressReleases.title,
                        meta: formatSingleDate(pressReleases.postDate, formats.dayMonthYear),
                        uri: pressReleases.uri,
                        pills: this.getCardPills(pressReleases),
                    };
                });
            }
            return null;
        }
    },

    watch: {
    Watch the query parameter "page" for changes. Change "page" if you use a different query-param.
        '$route.query.page': {
            handler(pageNumber) {
                if (pageNumber) {
                    this.currentPage = Number(pageNumber);
                } else {
                    this.currentPage = 1;
                }
            },
            deep: true,
            immediate: true
        },
        currentPage() {
            window.scrollTo(0, 0);
            this.$fetch();
        },
    }
};
</script> -->
